module.exports = __webpack_public_path__ + "static/media/icon_done-white.a66d6ebe.svg";